module.exports = __webpack_public_path__ + "img/logo_jamworks.5730d2f4.svg";